import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { IMPERSONATION_REQUEST_DETAIL_RESOURCE } from '../constants';

const impersonationRequestDetailService = ComposedComponent =>
  reduxFetch([
    {
      resource: IMPERSONATION_REQUEST_DETAIL_RESOURCE,
      method: 'get',
      request: id => ({
        url: apiRoutes.impersonationRequest(id),
      }),
    },
  ])(ComposedComponent);

export default impersonationRequestDetailService;
